<template>
  <div class="detail-content">
    <heads title="预览" :isShowSave="false"></heads>
    <div class="preview-info">
      <el-scrollbar style="height: 100%" ref="myScrollbar" class="page-component__scroll">
        <div v-html="articleInfo.articlecontent" class="preview-box"></div>
      </el-scrollbar>
      <el-backtop target=".page-component__scroll .el-scrollbar__wrap" :bottom="100">
        <i class="el-icon-arrow-up"></i>
      </el-backtop>
    </div>
  </div>
</template>
<script>
import api from "@/api/news/publish.js";
import heads from "@/components/header.vue";
export default {
  components: { heads },
  data() {
    return {
      articleInfo: {},
      content: ""
    };
  },
  computed: {
    id() {
      return this.$route.query.id;
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      let res = await this.$http.get(`${api.articleInfo}?id=${this.id}`);
      if (res && res.isSucceed) {
        this.articleInfo = res.rows && res.rows.length > 0 ? res.rows[0] : {};
      }
    }
  }
};
</script>
<style lang='less' scoped>
@import url("./detail.less");
</style>
<style lang="less">
  .el-scrollbar__wrap{
    overflow-x: hidden;
  }
</style>